export const ADMIN_USERS = [
    "ishan@gmail.com",
    "harsh@gmail.com",
    "xsmeke72@gmail.com",
  ];

export const isAdmin = (email) => ADMIN_USERS.includes(email);
  


// WEBPACK FOOTER //
// ./src/adminUsers.js